export default __webpack_public_path__ + "static/start_bg-4350821e9e97658d705b88d74e2d6dc0.png";